import { handleLocalStorage } from '@utils';

import { globalActions } from '@modules/global';
import { TMiddleware } from '@modules/types';

import { checkActionsType } from './utils';

const { setItem } = handleLocalStorage;

export const changeScheme: TMiddleware = () => next => action => {
  if (checkActionsType(action, [globalActions.setScheme])) setItem('scheme', action.payload);
  return next(action);
};

export default changeScheme;
